import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Container from './component/div/Container';

class Main extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.history.push('/about/vision');
  }

  render() {
    const currentPath = this.props.location.pathname;

    return (
      // 웹
      <React.Fragment>
        <Container currentPath={currentPath}></Container>
      </React.Fragment>
    );
  }
}

export default withRouter(Main);
